
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { ShippingTips } from '@/features/shipment/types';

import { updateNotificationPref } from '@/features/settings/services/notifications.services';
import focusMixin from '@/features/common/mixins/focusMixin';

@Component
export default class ShippingTipsNotification extends Mixins(focusMixin) {
  @Prop({ required: true }) shippingTips!: ShippingTips;

  private show = false;

  private isDontShowNotification = false;

  get countryName(): string {
    const countryInfo = this.$store.getters.getCountryFromCode(this.shippingTips.countryCode);
    const name = countryInfo ? countryInfo.country : '';
    return `${this.addTheToCountryName(name)} ${this.pascalCasing(name)}`;
  }

  private pascalCasing = (countryName: string) => {
    const countryStr = countryName.trim().toLowerCase();

    const countryStrArr = countryStr.split(' ');
    for (let i = 0; i < countryStrArr.length; i += 1) {
      countryStrArr[i] = countryStrArr[i][0].toUpperCase()
        + countryStrArr[i].substr(1, countryStrArr[i].length);
    }
    return countryStrArr.join(' ');
  }

  private addTheToCountryName = (countryName: string) => {
    const countryStr = countryName.trim().toLowerCase();

    if (countryStr.indexOf('st. ') === 0) return '';

    if (countryStr === 'bahamas') return 'the ';

    if (countryStr.slice(countryStr.length - 1) === 's' && countryStr !== 'barbados') {
      return 'the ';
    }

    if (countryStr.indexOf('united') !== -1
      || countryStr.indexOf('republic') !== -1
      || countryStr === 'gambia') {
      return 'the ';
    }

    return '';
  }

  private neverShowHelpfulInfoNotification() {
    this.$store.commit('patchNotificationPref', {
      name: 'CICountryRequirements',
      value: !this.isDontShowNotification,
    });
    updateNotificationPref('CICountryRequirements', !this.isDontShowNotification);
  }

  private showMeTips = () => {
    window.open(window.location.origin + this.shippingTips.url);
  }
}
